/**
 * UTM Linker - Frontend script
 * Entry point for the UTM Linker plugin
 */

import UtmLinker from './UtmLinker.js';

// Initialize UTM Linker when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Prevent multiple initializations
    if (window.utmLinkerInitialized) {
        console.warn('UTM Linker already initialized');
        return;
    }
    
    // Get settings from WordPress
    const settings = typeof utmLinkerSettings !== 'undefined' ? utmLinkerSettings : {};
    
    // Initialize UTM Linker. A constructor throw must never be left
    // unhandled: it would run before debugMode is even read, so the
    // console.error here is deliberately unconditional (not gated on
    // settings.debugMode like processLinks()'s per-link catch is) — this is
    // the ONE signal the engine failed to boot at all.
    try {
        window.utmLinker = new UtmLinker(settings);
        window.utmLinkerInitialized = true;
    } catch (e) {
        console.error('UTM Linker: failed to initialize', e);
    }
});